import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import PopupLink from "../PopupLink";
import StarsIcons from "../StarsIcons";
import styles from "./StarsLink.scss";

const cx = classnames.bind(styles);

const StarsLink = React.forwardRef(
  ({ baseUrl, className, atiCode, imageLink, imgClassName, onClick }, ref) => (
    <PopupLink
      ref={ref}
      className={cx("stars", className)}
      href={
        atiCode &&
        `https://${baseUrl}/firms/${atiCode}/passport?utm_source=header&utm_campaign=new_header`
      }
      name="stars-link"
      onClick={onClick}
    >
      <StarsIcons
        imageLink={imageLink}
        imgClassName={imgClassName}
        baseUrl={baseUrl}
        atiCode={atiCode}
      />
    </PopupLink>
  )
);

StarsLink.defaultProps = {
  baseUrl: "ati.su",
};

StarsLink.propTypes = {
  imageLink: PropTypes.string,
  atiCode: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  baseUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default StarsLink;
